import type { OperationalLayerRow } from '../types'

function nonEmptyRestriction(raw: unknown): boolean {
  if (raw == null) return false
  if (Array.isArray(raw)) return raw.length > 0
  if (typeof raw === 'string') {
    const t = raw.trim()
    if (!t || t === 'null' || t === '[]') return false
    try {
      const parsed = JSON.parse(t) as unknown
      return Array.isArray(parsed) && parsed.length > 0
    } catch {
      return false
    }
  }
  return false
}

/** layer visible by all (no list of users/groups). */
export function layerSharingKind(
  layer: OperationalLayerRow,
): 'public' | 'shared' {
  const users = nonEmptyRestriction(layer.visible_to_users)
  const groups = nonEmptyRestriction(layer.visible_to_groups)
  return users || groups ? 'shared' : 'public'
}
